// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__8o6h-","spin":"Spinner_spin__AHwtU"};